export default "__VITE_ASSET__57ac1a3f__"